import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import AlertPanel from 'components/AlertPanel';
import { H2, Body1, H5 } from 'components/Typography';
import Label from 'components/Label';
import classNames from 'classnames';
import styles from './styles';
import isStringSet from 'utilities/is/isStringSet';

const NameValuePair = (props) => (
    <div className={props.classes.namePairContainer}>
        <Label {...props.labelProps}>{props.name}</Label>
        <Body1 {...props.valueProps}>{props.value}</Body1>
    </div>
);

class VisitorPassView extends React.Component {
    render() {
        const { classes, pass, status, disableBackButton } = this.props;

        if (!Boolean(pass)) {
            return (<React.Fragment></React.Fragment>);
        }

        const actions = React.Children.map(this.props.children, (child, index) =>
            React.cloneElement(child, {
                key: index,
                className: classNames(classes.actionButtons, child.props.className)
            }));

        const title = `${pass.firstname} ${pass.surname}`;
        const hideBackButton = Boolean(disableBackButton);

        return (
            <div>
                <Dialog fullScreen open={true}>
                    <AppBar className={classes.appBar} color="primary">
                        <Toolbar>
                            {!hideBackButton &&
                                <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                    <ArrowBackIcon />
                                </IconButton>
                            }
                            <Typography variant="h6" color="inherit" className={classes.flex} noWrap>
                                {title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent className={classes.contentBody}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <H2 paragraph>
                                    Visitor pass
                                </H2>
                            </Grid>

                            <Grid item xs={12}>
                                {status.isWarning &&
                                    <AlertPanel className={classes.warningPanel} message={status.statusMessage} variant="error" />
                                }
                            </Grid>

                            <Grid item xs={12}>
                                <H5 paragraph>
                                    Visitor overview
                                </H5>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <img
                                    src={"data:image/png;base64," + pass.photo}
                                    className={classes.photo}
                                    alt="Visitor Pass"
                                    title="Photo" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <NameValuePair name="Visitor" value={`${pass.firstname} ${pass.surname}`} classes={classes} />
                                <NameValuePair name="Valid From" value={pass.startDate} classes={classes} />
                                <NameValuePair name="Valid To" value={pass.endDate} classes={classes} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <NameValuePair name="Site" value={pass.siteName} classes={classes} />
                                <NameValuePair name="Pass Number" value={pass.visitorPassNumber} classes={classes} />
                                <NameValuePair name="Status" value={status.statusMessage} classes={classes} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <NameValuePair name="Visiting" value={pass.hostFirstName + ' ' + pass.hostSurname} classes={classes} />
                                <NameValuePair name="Contact Number" value={pass.principalContactNumber} classes={classes} />
                                {isStringSet(pass.vehicle) && pass.vehicle !== " , " &&
                                    <NameValuePair name="Vehicle" value={pass.vehicle} classes={classes} />
                                }
                                {isStringSet(pass.vehicleReg) &&
                                    <NameValuePair name="Registration" value={pass.vehicleReg} classes={classes} />
                                }
                                <NameValuePair name="Mobile Number" value={pass.mobileNumber} classes={classes} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        {actions}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(VisitorPassView);
